import { create } from 'zustand';
import { saveUtilityCache } from '../../../utils/utilityAppStorage';
import { validatePlanChange } from '../utils/loadProgression';
const readPlans = () => {
  try { return JSON.parse(localStorage.getItem('fitnessData') || '{}').loadPlans || []; }
  catch { return []; }
};
export const useLoadPlanStore = create((set, get) => ({
  plans: readPlans(),
  savePlans: inputs => {
    if (new Set(inputs.map(input => input.exerciseId)).size !== inputs.length) throw new Error('Hay ejercicios duplicados.');
    const current = get().plans;
    const updates = inputs.map(input => ({ ...validatePlanChange(input, current.find(plan => plan.exerciseId === input.exerciseId)),
      id: input.exerciseId, updatedAt: new Date().toISOString() }));
    const merged = new Map(current.map(plan => [plan.exerciseId, plan]));
    updates.forEach(plan => merged.set(plan.exerciseId, plan));
    const plans = [...merged.values()];
    const data = JSON.parse(localStorage.getItem('fitnessData') || '{}');
    saveUtilityCache('fitnessData', { ...data, loadPlans: plans });
    set({ plans });
  },
  savePlan: input => {
    const previous = get().plans.find(plan => plan.exerciseId === input.exerciseId);
    const resolved = validatePlanChange(input, previous);
    const plan = { ...resolved, id: input.exerciseId, updatedAt: new Date().toISOString() };
    const plans = previous ? get().plans.map(row => row.exerciseId === plan.exerciseId ? plan : row) : [...get().plans, plan];
    const data = JSON.parse(localStorage.getItem('fitnessData') || '{}');
    saveUtilityCache('fitnessData', { ...data, loadPlans: plans });
    set({ plans });
    return plan;
  },
}));
export const rehydrateLoadPlans = () => useLoadPlanStore.setState({ plans: readPlans() });
